import {SponsorshipDomainModel} from "./sponsorship.domain-model";
import {SponsorshipLogoParams} from "./sponsorship-logo-params";
import {BaseViewModel} from "../../../infrastructure/models/base-view-model";

export class SponsorshipViewModel extends BaseViewModel {
  domainModel: SponsorshipDomainModel;
  isSmallView: Boolean;

  constructor(domainModel: SponsorshipDomainModel, isSmallView, isCircle: Boolean) {
    super(domainModel);

    this.isSmallView = isSmallView;
    this.isCircle = isCircle;
  }

  get logo(): SponsorshipLogoParams {
    const name: String = this.isCircle ? this.domainModel.mobileName : this.domainModel.desktopName;
    return new SponsorshipLogoParams(name, this.isCircle);
  }

  get externalUrl() {
    return this.isSmallView ? this.domainModel.mobileUrl : this.domainModel.desktopUrl;
  }
}
